import { render } from "./SocialManagement.vue?vue&type=template&id=04e51d66&scoped=true"
import script from "./SocialManagement.vue?vue&type=script&lang=js"
export * from "./SocialManagement.vue?vue&type=script&lang=js"

import "./SocialManagement.vue?vue&type=style&index=0&id=04e51d66&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e51d66"]])

export default __exports__